import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, ViewChild, inject, OnDestroy, ElementRef, TemplateRef } from '@angular/core';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';

import {DialogService} from '@wms/services';

@Component({
  selector: 'wms-dialog',
  standalone: true,
  templateUrl: './wms-dialog.component.html',
  styleUrls: ['./wms-dialog.component.less'],
  imports: [
    CommonModule,
    ModalModule,
  ],
})
export class WmsDialogComponent implements OnInit, OnDestroy {
  @Input() id!: string;
  @Input() customClasses!: string;
  @Input() position!: string;
  @Input() dialogid!: string;
  @ViewChild('wmsDialog', { static: false }) wmsDialog?: ModalDirective;
  @Input() content: TemplateRef<any> | undefined;
  @Input()
  serviceToInvoke: any;
  @Input()
  dialogParams: Object;
  isModalShown = false;
  dialogService: DialogService;
  private element: any;
  private service: any;
  @Input() closeOnEscape: boolean = true;
  @Input() showBackdrop: boolean = true;

  constructor(private el: ElementRef) {
    this.dialogService = inject(DialogService);
    this.element = el.nativeElement;
  }

  ngOnInit(): void {
    document.body.appendChild(this.element);
    this.dialogService.add(this);
  }

  showModal(params?: any): void {
    this.isModalShown = true;
    if (!this.serviceToInvoke) {
      this.serviceToInvoke = this.id + 'Controller'
    }
    if(params){
      this.dialogParams=params;
      if(params.customClasses) {
        this.customClasses = params.customClasses;
      }
    }
    // the last opened dialog should have the highest zIndex to be visible on top
    const openedDialogs = this.dialogService.openedDialogs;
    if (openedDialogs.length > 1) {
      const lastOpenedDialogId = openedDialogs[openedDialogs.length - 1];
      setTimeout(() => {
        const lastOpenedDialogEl = $('[id=' + lastOpenedDialogId + '] > div')
        if (lastOpenedDialogEl.length) {
          lastOpenedDialogEl[0].style.zIndex = (parseInt(window.getComputedStyle(lastOpenedDialogEl[0]).zIndex) + openedDialogs.length).toString();
        }
      }, 0);
    }
  }

  hideModal(): void {
    this.wmsDialog?.hide();
    this.isModalShown = false;
  }

  removeModal(): void {
    this.hideModal();
    if (!this.dialogService.storeDialogRef) {
      // this.dialogService.remove(this.id);
      // this.element.remove();
    }
  }

  // remove self from modal service when component is destroyed
  ngOnDestroy(): void {
    if (!this.dialogService.storeDialogRef) {
      this.dialogService.remove(this.id);
      this.element.remove();
    }
  }
}
